import hardDelete from './HardDelete';

const operations: { [key: string]: any } = {
    HardDelete: hardDelete,
};

export default operations;
